import React from 'react';
import { COMPANY_INFO } from '../utils/constants';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-white py-10 sm:py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-10 sm:mb-12">
          <div className="lg:col-span-2">
            <h3 className="font-display text-lg sm:text-xl font-semibold mb-4 sm:mb-5 tracking-tight text-white">
              {COMPANY_INFO.name}
            </h3>
            <p className="text-primary-300 mb-5 sm:mb-6 leading-relaxed text-sm sm:text-[15px] max-w-xl">
              专业从事消防产品开发、生产、销售、维修、消防检测及灭火器维修的消防整体解决服务商。
              拥有消防设施检测资质和消防工程安装资质，是北京消防协会会员单位。
            </p>
            <div className="flex items-center flex-wrap gap-x-6 gap-y-2 text-primary-400 text-xs sm:text-sm tracking-wide">
              <span>正规资质</span>
              <span className="text-primary-700">|</span>
              <span>24小时服务</span>
              <span className="text-primary-700">|</span>
              <span>专业团队</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 sm:mb-5 tracking-wide text-white/90 uppercase">
              服务项目
            </h4>
            <ul className="space-y-2.5 text-primary-300">
              <li className="text-sm sm:text-[15px]">消防安全检测评估</li>
              <li className="text-sm sm:text-[15px]">消电检测 防雷检测</li>
              <li className="text-sm sm:text-[15px]">消防设备维修</li>
              <li className="text-sm sm:text-[15px]">灭火器年检维修</li>
              <li className="text-sm sm:text-[15px]">消防产品批发销售</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 sm:mb-5 tracking-wide text-white/90 uppercase">
              联系我们
            </h4>
            <div className="space-y-2.5 text-primary-300">
              <div className="text-sm sm:text-[15px]">186-0038-5876</div>
              <div className="text-sm sm:text-[15px] break-all">841854015@qq.com</div>
              <div className="text-sm sm:text-[15px]">北京市朝阳区</div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-800 pt-6 sm:pt-8 text-center">
          <p className="text-primary-400 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-x-3 gap-y-1 tracking-wide">
            <span>&copy; {currentYear} {COMPANY_INFO.name}. 保留所有权利.</span>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary-200 transition-colors"
            >
              京ICP备2025127951号-1
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
